/**
 * The imports below are used to initialize components from the regular PDP page.
 */
import "init/jiffy";
import "common/base";

import "components/jiffy/canada-redirect-modal/canada-redirect-modal";
import "components/jiffy/free-shipping-banner/free-shipping-banner";
import "components/jiffy/masthead/masthead";
import initMastheadRedesign2025 from "components/jiffy/masthead-redesign2025/masthead-redesign2025";
import initProductsFilter from "components/jiffy/products-filter/products-filter";
import "components/jiffy/price-line-through/price-line-through";
import "components/jiffy/app-store-badge/app-store-badge";

import "components/jiffy/product-card-badge/product-card-badge";
import "components/jiffy/button-box/button-box";
import "components/jiffy/text-box/text-box";
import "components/jiffy/check-box/check-box";
import "components/jiffy/input-box/input-box";
import "components/jiffy/radio-box/radio-box";
import "components/jiffy/flash-messages/flash-messages";
import "components/jiffy/fast-delivery-information/fast-delivery-information";
import "components/spinner/component";
import "components/jiffy/jiffy-pagination/jiffy-pagination";
import initJiffyFirstBadges from "components/j1_badge/component"; // We load this component once on Mobile filters in Masthead
import initAccessibility from "common/jiffy/accessibility";
import initModalWrapper from "components/jiffy/modal-wrapper/modal-wrapper";
import initSocialLinks from "components/jiffy/social-icons/social-icons";
// end;

// Mobile App CSS
import "components/jiffy/masthead/masthead-mobile.scss"; // Need to add bottom margin to back to results

// Reviews section from Blank PDP
import "components/jiffy/product-details/product-details.scss"; // This is needed for the reviews section layout
import initReviews from "components/jiffy/reviews-list/reviews-list";
import initReviewSummary from "components/jiffy/review-summary/review-summary";

// PDP
import "components/jiffy/digital-assets/digital-assets-pdp-wrapper/digital-assets-pdp-wrapper";
import "components/jiffy/digital-assets/digital-assets-pdp-description/digital-assets-pdp-description";
import digitalAssetsPdpSlider from "components/jiffy/digital-assets/digital-assets-pdp-slider/digital-assets-pdp-slider";
import "components/jiffy/digital-assets/digital-assets-pdp-summary/digital-assets-pdp-summary";
import { licenseToggle as digitalAssetsLicenseToggle } from "components/jiffy/digital-assets/digital-assets-pdp-details/digital-assets-pdp-details";
import "components/jiffy/digital-assets/digital-assets-relative-assets/digital-assets-relative-assets";
import digitalAssetsPdpImage from "components/jiffy/digital-assets/digital-assets-pdp-image/digital-assets-pdp-image";
import "components/jiffy/digital-assets/digital-assets-seller-verified/digital-assets-seller-verified";
import digitalAssetsUploadForm from "components/jiffy/digital-assets/digital-assets-assets-upload-form/digital-assets-assets-upload-form";
import digitalAssetsLicenseModal from "components/jiffy/digital-assets/digital-assets-license-modal/digital-assets-license-modal";
import digitalAssetsDTFModalToggles from "components/jiffy/digital-assets/digital-assets-dtf-buttons/digital-assets-dtf-buttons";
import digitalAssetsDTFModal from "components/jiffy/digital-assets/digital-assets-dtf-modal/digital-assets-dtf-modal";
import digitalAssetsDtfModalItems from "components/jiffy/digital-assets/digital-assets-dtf-modal/digital-assets-dtf-modal-items/digital-assets-dtf-modal-items";
import digitalAssetsStoreFrontBar from "components/jiffy/digital-assets/digital-assets-storefront-pdp-bar/digital-assets-storefront-pdp-bar";
import digitalAssetsStorefrontAssetToggle from "components/jiffy/digital-assets/digital-assets-storefront-active-toggle/digital-assets-storefront-active-toggle";

// Common
import initDigitalAssetsCard from "./digital-assets/digital-assets-asset-card";
import initDigitalAssetsAddToCart from "./digital-assets/digital-assets-add-to-cart";
import initDigitalAssetsMyLibrary from "./digital-assets/digital-assets-my-library";
import "./digital-assets/digital-assets-common";

const initDigitalAssetsPdp = () => {
  const modalItems = digitalAssetsDtfModalItems();
  const dtfModal = digitalAssetsDTFModal({
    closeCallback: () => modalItems.stopLoading()
  });
  const licenseModal = digitalAssetsLicenseModal();
  digitalAssetsUploadForm().initDropzone();
  digitalAssetsPdpImage();
  digitalAssetsPdpSlider();
  digitalAssetsLicenseToggle({
    eventCallback: () => licenseModal.toggleModal()
  });
  digitalAssetsDTFModalToggles({
    eventCallback: (_, { dataset }) => dtfModal.openModal(dataset.section)
  });
};

const initPdpStorefront = () => {
  const bar = digitalAssetsStoreFrontBar();
  digitalAssetsStorefrontAssetToggle({
    eventCallback: () => bar.toggleActiveClass()
  });
};

document.addEventListener("DOMContentLoaded", () => {
  initDigitalAssetsPdp();
  initDigitalAssetsCard();
  initDigitalAssetsAddToCart();
  initPdpStorefront();
  initDigitalAssetsMyLibrary();
  initMastheadRedesign2025();
  initProductsFilter();

  // From Regular PDP
  initReviews();
  initReviewSummary();
  initAccessibility();
  initModalWrapper();
  initJiffyFirstBadges();
  initSocialLinks();
});
